import $events from 'wee-events';
import $ from 'wee-dom';
import numWords from 'num-words';
import $mediator from 'wee-mediator';
import { _win } from 'core/variables';
import $location from 'wee-location';
import { RouteHandler } from 'wee-routes';
import { ios, iphoneX, safari } from '../../scripts/ua';
import KeyHelper from '../../scripts/keyhelper';
import ScrollToAnchor from '../../scripts/scrollToAnchor';

const getGcd = (width, height) => (height == 0) ? width : getGcd(height, width%height);

const getAspectRatioClass = (width, height) => {
    const gcd = getGcd(width, height);

    return `${numWords(width / gcd)}-${numWords(height / gcd)}`;
};

export default new RouteHandler({
    init() {
        const classes = [];

        if (ios && safari) {
            classes.push('ios-safari');
        }

        if (iphoneX) {
            classes.push('iphone-x');
        }

        $('body').addClass(classes.join(' '));

        $('.search-desktop').addClass('-is-loaded');

        $('a').filter((i, { hostname }) => hostname && hostname !== _win.location.hostname)
            .addClass('-is-external');

        $events.on({
            body: {
                keyup(e) {
                    if (KeyHelper.isEsc(e)) {
                        $mediator.emit('body.esc', e);
                    }
                },
            },
            ':skipToContent': {
                click() {
                    $mediator.emit('global.skipToContent');
                },
            },
        });

        $(':hero').find('a.button').each((item) => {
            const { hash, origin: hrefOrigin } = $location.uri(item.href);
            const { origin } = $location.uri();

            // Check if hash exists and that we're not linking to a different url
            if (hash && hrefOrigin === origin) {
                $events.on(item, 'click', (e) => {
                    new ScrollToAnchor(e, {
                        target: `#${hash}`,
                        smooth: true,
                    }).scroll();
                });
            }
        });

        $('figure').each((item) => {
            const $item = $(item);

            if ($item.contains('iframe')) {
                const $frame = $item.find('iframe');
                const width = $frame.attr('width');
                const height = $frame.attr('height');
                let aspectClass = '';

                if (width && height) {
                    aspectClass = `-${getAspectRatioClass(
                        parseInt(width),
                        parseInt(height),
                    )}`;
                }

                $item.addClass(`video-embed ${aspectClass}`);

                $frame.attr('style', '').on('load', () => {
                    $item.addClass('-loaded');
                });
            }
        });
    },
});
